var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.109,
    height: 19.109,
    viewBox: "0 0 19.109 19.109",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(6.425 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M183.531,1.312a4.479,4.479,0,0,0-6.334,0l-3.743,3.743a4.521,4.521,0,0,0,0,6.334,4.263,4.263,0,0,0,.9.683l.683-.683a1.538,1.538,0,0,0,.282-1.35,2.163,2.163,0,0,1-.282-.233,2.263,2.263,0,0,1,0-3.167L178.781,2.9a2.239,2.239,0,0,1,3.167,3.167l-2.474,2.474a6.446,6.446,0,0,1,.28,2.881c.011-.011.024-.017.034-.028l3.743-3.743A4.479,4.479,0,0,0,183.531,1.312Z",
    transform: "translate(-172.159 0)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 6.747)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M11.679,181.459a4.262,4.262,0,0,0-.9-.683l-.683.683a1.538,1.538,0,0,0-.282,1.35,2.156,2.156,0,0,1,.282.233,2.263,2.263,0,0,1,0,3.167l-4.033,4.033A2.239,2.239,0,1,1,2.9,187.076l2.764-2.764a6.445,6.445,0,0,1-.28-2.881c-.011.011-.024.018-.035.028l-4.033,4.033a4.479,4.479,0,0,0,6.334,6.334l4.033-4.033A4.519,4.519,0,0,0,11.679,181.459Z",
    transform: "translate(0 -180.776)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link-icon.e1f1824372c227709e4cba8aa9178c27.svg";
export { ForwardRef as ReactComponent };